<template>
    <div class="campaign-editor">
        <div id="editor-frame" :class="mode==='tiles' ? 'frame-tiles' : 'frame-list'"  @click.self="tap()">
            <div id="editor-canvas" :class="mode==='tiles' ? 'canvas-tiles' : 'canvas-list scrollBox'"
                 :style="canvasStyles()"
                 @click.self="tap()"
                 @scroll.passive="handleEditorScroll">
                <div v-if="dragdropDragging || !data?.elements?.length"
                     class="dragdrop-placeholder"
                     :style="placeholderPositionStyle">
                    <div class="wrapper font-bold bg-muted">
                        <div class="dragdrop-placeholder-text">
                            {{ dropHereMessage }}
                        </div>
                    </div>
                </div>
                <div v-if="data !== null" :class="mode==='tiles' ? '' : 'editor-list'"

                     @click.self="tap()"
                >
                    <draggable v-model="data.elements"
                               @start="drag=true"
                               @end="drag=false;dragEnd($event)"
                               handle=".campaign-element"
                               :style="mode === 'tiles' ? 'width:fit-content' : ''"
                               v-if="!dynamic">
                        <component is="elementInCampaign" v-for="(element, key) in data.elements"
                                   :data="element"
                                   v-model="active_element"
                                   :key="key"
                                   :index="key"
                                   :parameters="data.parameters"
                                   :is_diabled="is_disabled"
                                   :saving="saving"
                                   :grid="grid"
                                   :mode="mode"
                                   :default_duration="data.default_duration"
                                   :mustConvert="mustConvert"
                                   :dynamic="dynamic"
                                   :interactive="interactive"
                                   :size="lineSize"
                                   :layoutInfo="layoutInfo"
                                   :windowInfo="windowInfo"
                                   :allLayers="data.all_layers"
                                   @tapped="tap"
                        />
                    </draggable>
                    <div v-else :style="mode === 'tiles' ? 'width:fit-content' : ''">
                        <component is="elementInCampaign" v-for="(element, key) in data.elements"
                                   :data="element"
                                   v-model="active_element"
                                   :key="key"
                                   :index="key"
                                   :parameters="data.parameters"
                                   :is_diabled="is_disabled"
                                   :saving="saving"
                                   :grid="grid"
                                   :mode="mode"
                                   :default_duration="data.default_duration"
                                   :mustConvert="mustConvert"
                                   :dynamic="dynamic"
                                   :interactive="interactive"
                                   :size="lineSize"
                                   :layoutInfo="layoutInfo"
                                   :windowInfo="windowInfo"
                                   @tapped="tap();">
                        </component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import elementInCampaign from './element.vue'

    export default {
        props: [
            'data',
            'value',
            'mustConvert',
            'inline',
            'grid',
            'mode',
            'back_url',
            'basicPrivilege',
            'advancedPrivilege',
            'dynamic',
            'interactive',
            'lineSize',
            'dragdropDragging'
        ],
        components: {
            draggable,
            elementInCampaign
        },
        data: function () {
            return {
                saving: false,
                width: '1',
                height: '1',
                active_element: -1,
                windowInfo: null,
                layoutInfo: null,

                editorScrollPos: 0,
            }
        },
        computed: {
            dropHereMessage() {
                if (this.dynamic) {
                    return Lang.langGet('No content with matching tags available.');
                }
                return Lang.langGet("Use Drag & Drop to add elements from the box on the left to this campaign.");
            },
            is_disabled: function () {
                let locked = this.data.locked,
                    readonly = this.data.readonly;

                return (locked === true || readonly === true);
            },
            placeholderPositionStyle() {
                return this.mode === 'tiles' ? { left: `${this.editorScrollPos}px` } : { position: this.editorScrollPos == 0 ? 'absolute' : 'sticky' }
            }
        },
        watch: {
            active_element: function (val) {
                this.$emit('input', val);

                if (val !== -1) {
                    EaseEventBus.fire('expandSettings');
                }

                this.$nextTick(function () {
                    $('.input-group.date').datepicker('update');
                });
            },
            value: function () {
                this.active_element = this.value;
            },
        },
        methods: {
            tap: function() {
                EaseEventBus.fire('expandSettings');

                this.active_element = -1;
                $('html').css('cursor', 'auto');

                this.$nextTick(function () {
                    EaseEventBus.fire('reinitializeDragula');
                });

                $('input').blur();
                this.$emit('input', this.active_element);
            },
            canvasStyles: function () {
                if (this.mode === 'tiles') {
                    return {};
                } else {
                    var h = 100;

                    let layoutInfo = this.layoutInfo;
                    let windowInfo = this.windowInfo;
                    if(layoutInfo && windowInfo) {
                        h = Math.max(layoutInfo.minHeight, windowInfo.contentHeight) - layoutInfo.actionButtonsHeight - 2 * layoutInfo.editorPadding - 10; // 10px padding is being added somewhere, just fix it statically
                    }

                    return {
                        height: h + 'px',
                        maxHeight: h + 'px'
                    }
                }
            },
            dragEnd: function (event) {
                let smaller = Math.min(event.oldIndex, event.newIndex);
                let bigger = Math.max(event.oldIndex, event.newIndex);
                if(event.oldIndex !== event.newIndex) {
                    EaseEventBus.fire('unsavedChanges', true);
                }
                if(this.active_element >= smaller && this.active_element <= bigger) {
                    let step = 0;
                    if(event.oldIndex < event.newIndex) {
                        step = -1;
                    } else if(event.oldIndex > event.newIndex) {
                        step = 1;
                    }
                    if(event.oldIndex === this.active_element) {
                        this.active_element = event.newIndex;
                    } else {
                        this.active_element = this.active_element + step;
                    }
                }
            },
            handleEditorScroll (e) {
                this.editorScrollPos = this.mode==='tiles' ? e.target.scrollLeft : e.target.scrollTop
            }
        },
        mounted() {

            EaseEventBus.listen('windowInfo', (data) => {
                this.windowInfo = _.extend({}, this.windowInfo, data);
            });
            EaseEventBus.listen('layoutInfo', (data) => {
                this.layoutInfo = _.extend({}, this.layoutInfo, data);
            });
        }
    }
</script>
